<div fxLayout="column" fxLayoutGap="15px" class="change-regional-container">
  <div fxLayout="row">
    <h2>Wybierz Saldo</h2>
  </div>


  <div fxLayout="row" fxFlex="100">
    <app-dict-receivables-balance fxFlex="100" [formControl]="receivablesBalanceControl"> </app-dict-receivables-balance>
  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !changeReceivablesBalanceForm.valid"
    ><mat-icon>add</mat-icon><span> Zapisz</span></button>

    <button (click)="closeDialog($event)" mat-raised-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

